export default "/images/vendor/flag-icon-css/flags/4x3/st.svg?72697a87cfc011963be4361604931288";